import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  getColor,
  Modal,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import { Workgroup } from "../../types/workgroup";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { useNavigate } from "react-router-dom";
import utilsCommon from "../../shared/utils/common";
import { nanoid } from "@reduxjs/toolkit";
import { t } from "i18next";
import i18n from "fds/src/locales/i18n";

interface WorkgroupDeleteModalProps {
  open: boolean;
  onClose: () => void;
  workgroupInfo?: Workgroup;
  handleAfter?: () => void;
}
const WorkgroupDeleteModal: React.FC<WorkgroupDeleteModalProps> = ({
  open,
  workgroupInfo,
  onClose,
  handleAfter,
}) => {
  /** hook 정리 */
  const navigate = useNavigate();
  const toasts = useToast();
  const { getWorkgroupUpdateStatus } = useWorkgroupStore();

  /** 함수 정리 */
  /** 워크그룹 삭제 */
  const handleDeleteModal = async () => {
    if (!workgroupInfo) return;
    if (window.location.pathname.includes(workgroupInfo.workgroupId))
      navigate(`${process.env.PUBLIC_URL}/home`);
    utilsCommon.sleep(2000);

    let resp: any = await getWorkgroupUpdateStatus({
      workgroupId: workgroupInfo?.workgroupId,
      status: 0,
    });
    if (resp.payload) {
      onClose();
      handleAfter && handleAfter();
    } else {
      toasts.toastMsg(
        nanoid(),
        resp.error.message ?? t("common.alert.fail"),
        "error"
      );
    }
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      width={540}
      title={t("workgroup.deleteWorkgroup")}
      footer={
        <Box>
          <Button
            label={t("common.cancel")}
            btnStyle="fill"
            type="secondary"
            onClick={onClose}
          />
          <Button
            label={t("common.delete")}
            btnStyle="fill"
            type="error"
            state="hover"
            onClick={handleDeleteModal}
          />
        </Box>
      }
      classes="workgroupInfo-deleteModal"
      body={
        <Box direction="column">
          <Typography
            type="body2_rg_long"
            whiteSpace="break-spaces"
            exactColor={getColor("COLOR_ICON_INTERACTIVE_TERTIARY")}
          >
            {t("workgroup.deleteWorkgroupDesc")}
          </Typography>
          <Box classes="mg mt-8 workgroupInfo-deleteInfo">
            <Avatar
              uniqueCode={workgroupInfo?.workgroupId ?? ""}
              name={workgroupInfo?.workgroupName}
              shape="workgroup"
              size="40"
            />
            <Box
              direction="column"
              classes="mg ml-8"
              justifyContent="center"
              width={"calc(100% - 48px)"}
            >
              <Tooltip message={workgroupInfo?.workgroupName}>
                <Typography
                  type="body2_rg"
                  ellipsis
                  style={{ wordBreak: "break-word" }}
                >
                  {workgroupInfo?.workgroupName}
                </Typography>
              </Tooltip>

              <Box classes="mg mt-4" alignItems="center">
                <Typography
                  type="caption_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {`${t("workgroup.managerShort")}: `}
                </Typography>
                <Tooltip
                  message={workgroupInfo?.managerName}
                  maxWidth={"calc(100% - 130px)"}
                  classes="mg ml-2"
                >
                  <Typography
                    type="caption_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    as="p"
                    ellipsis
                  >
                    {workgroupInfo?.managerName}
                  </Typography>
                </Tooltip>

                <Typography
                  type="caption_rg"
                  classes={i18n.language.includes("ko") ? "" : "mg ml-4"}
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {i18n.language.includes("ko") ? ", " : "- "}
                  {`${t("workgroup.memberWithCount", {
                    count: workgroupInfo?.members.length,
                  })}`}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      }
    />
  );
};
export default WorkgroupDeleteModal;
